import '../PlicCanvas/vue/utils/polyfills';
import '../vue/common';
import '../PlicCanvas/vue/common/common-management';
import '../PlicCanvas/vue/common/common-management-with-subjects';
import Vue from 'vue';

import AdTemplates from './tabs/layouts/ad-templates/AdTemplates';
import AdTemplate from  './tabs/layouts/ad-templates/AdTemplate';
Vue.component('ad-templates', AdTemplates);
Vue.component('ad-template', AdTemplate);

import SubjectUploader from '../PlicCanvas/vue/uploader/SubjectUploader';
Vue.component('subject-uploader', SubjectUploader);

import BatchHeader from '../PlicCanvas/vue/tabs/subject-management/BatchHeader';
Vue.component('subject-management-batch-header', BatchHeader);

import bbobHTML from '@bbob/html';
import presetHTML5 from '@bbob/preset-html5';
window.convertToBBCode = (bbcode) => {
	return bbobHTML(bbcode, presetHTML5()).replace(/(?:\r\n|\r\r|\r|\n)/g, '<br/>')
};

import createSubjectMenuItem from '../PlicCanvas/js/load/create-subject-menu-item';
window.createSubjectMenuItem = createSubjectMenuItem;

import usStates from '../PlicCanvas/vue/common/us-state-list';
window.usStates = usStates;

window.tabComponents.AdPageWizard = {
	component: () => import(/* webpackChunkName: "AdPageWizard" */ './tabs/ads/AdWizard.vue'),
	events: {
		insertAd: function(adData) {
			$('#adsTable').dataTable().fnAddDataAndDisplay(adData);
			window.returnToMainTab();
		}
	},
	registerSubTabForSchoolChange: true
};
window.tabComponents.AdvisorDashboard = {
	component: () => import(/* webpackChunkName: "AdvisorDashboard" */ './tabs/advisor-dashboard/AdvisorDashboard'),
	props: () => {
		let studioName = 'your Studio';
		if($.studioBranding) {
			studioName = $.studioBranding.name;
		}
		
		return {
			project: null,
			studioName: studioName,
			studioCoverLocked: $.getStudioSetting('coverLocked'),
			userPermissions: $.userPermissions
		};
	},
	registerForSchoolChange: {
		onSchoolChangeHandler: function(props, school) {
			props.project = school;
		}
	},
	hasCardOutline: true
};
window.tabComponents.ContentBooks = {
	component: () => import(/* webpackChunkName: "ContentBooks" */ './tabs/content-books/RenderContentBooks'),
	props: () => {
		let fontsList = $.merge([], $.GoogleFontList);

		let projectTypes = $.getSettingDefinitionFromSet($.projectSettings, 'projectType').options;
		let defaultProjectTypes = [...projectTypes];
		if($.allLoadedSchools && $.allLoadedSchools.length) {
			defaultProjectTypes = $.allLoadedSchools.reduce((projectTypes, school) => {
				if(school.projectType && !projectTypes.includes(school.projectType)) {
					projectTypes.push(school.projectType);
				}

				return projectTypes;
			}, []);

			// Studios might want to be able to print more types that they haven't created yet for prospects, but schools should only see what they are creating
			if(!$.userPermissions.viewAllProjectTypes) {
				projectTypes = defaultProjectTypes;
			}
		}

		return {
			projectTypes: projectTypes,
			defaultProjectTypes: defaultProjectTypes,
			fonts: fontsList,
			showGlobalThemes: $.getStudioSetting('showGlobalThemes', true),
			showGlobalBackgrounds: $.getStudioSetting('showGlobalBackgrounds', true),
			showGlobalClipArt: $.getStudioSetting('showGlobalClipArt', true),
			orgIds: [$.PlicOrgId]
		};
	},
	events: {
		
	}
};
window.tabComponents.ReportGenerator = {
	component: () => import(/* webpackChunkName: "ReportGenerator" */ './tabs/reports/ReportGenerator'),
	props: () => {
		return {
			projects: $.allSchoolsIncludingFiltered
		};
	},
	registerForSchoolListChange: function(props, schools) {
		props.projects = schools;
	}
};
window.tabComponents.SubjectOrderReceipt = {
	component: () => import(/* webpackChunkName: "SubjectOrderReceipt" */ './tabs/subject-orders/SubjectOrderReceipt'),
	props: () => {
		let order = $.activeOrderRow;
		if(order.original) {
			order = order.original;
		}

		return {
			bookStoreUrl: `${process.env.VUE_APP_BOOKS_STORE_HOST}/receipts/`,
			order: order,
			userPermissions: $.userPermissions
		};
	},
	events: {
		updateTablesForOrder: function(order) {
			if($.ordersTable) {
				$.ordersTable.dataTable().fnDisplayUpdatedData(order);
				$.ordersTable.api().rows().data().each(function (row, index) {
					if(row.original && row.original.orderId === order.orderId) {
						$.ordersTable.dataTable().fnDisplayUpdatedData(row);
					}
				});
				$.ordersTable.DataTable().draw();
			}
			if($.adsTable) {
				$.adsTable.dataTable().fnDisplayUpdatedData(order);
				$.adsTable.api().rows().data().each(function (row, index) {
					if(row.order && row.order.orderId === order.orderId) {
						$.adsTable.dataTable().fnDisplayUpdatedData(row);
					}
				});
				$.adsTable.DataTable().draw();
			}
			if($.personalizationsTable) {
				$.personalizationsTable.dataTable().fnDisplayUpdatedData(order);
				$.personalizationsTable.api().rows().data().each(function (row, index) {
					if(row.order && row.order.orderId === order.orderId) {
						$.personalizationsTable.dataTable().fnDisplayUpdatedData(row);
					}
				});
				$.personalizationsTable.DataTable().draw();
			}
		}
	},
	registerSubTabForSchoolChange: true
};
window.tabComponents.UserPageAssignments = {
	props: () => {
		return {
			user: $.activeUserRow,
			getProjectsForUser: window.getProjectsForUser
		};
	},
	component: () => import(/* webpackChunkName: "UserPageAssignments" */ '../management/tabs/users/page-assignments/PageAssignments.vue')
};
window.tabComponents.YearbookPersonalizationWizard = {
	props: () => {
		return {
			project: $.currentLoadedSchool
		};
	},
	events: {
		insertPersonalization: function(data) {
			$('#personalizationsTable').dataTable().fnAddDataAndDisplay(data);
			window.returnToMainTab();
		}
	},
	component: () => import(/* webpackChunkName: "YearbookPersonalizationWizard" */ './tabs/personalizations/YearbookPersonalizationWizard.vue'),
	registerSubTabForSchoolChange: true
};

window.tabComponents.ProjectWizard.props = () => {
	return {
		extraSettings: [
			{
				name: 'deadline',
				description: 'Book Deadline',
				type: 'date',
				value: $.getStudioSetting('defaultBookDeadline'),
				customRule: ''
			}
		]
	};
};
window.tabComponents.ProjectWizard.events = {
	insertProject: function(projectData) {
		var project = $.extend(projectData, {
			status: '-',
			pdf: {
				id: '-',
				pages: null,
				loading: false
			},
			cover: {
				id: '-'
			},
			pageLimit: projectData.settings.pageLimit,
			projectType: projectData.settings.projectType,
			storeEnabled: false,
			deadline: projectData.deadline
		});

		$('#organizationTable').dataTable().fnAddDataAndDisplay(project);
		window.addSchoolToDropdown(project);

		window.returnToMainTab();
	}
};

window.tabComponents.PublisherOrderWizard = {
	props: () => {
		let projectTypes = $.getSettingDefinitionFromSet($.projectSettings, 'projectType').options;
		return {
			publishers: $.publishers,
			publisherId: $.isPublisher ? $.RootOrgId : null,
			projectSettings: $.projectSettings,
			season: $.currentActiveSeason,
			parentOrgId: $.OrgId,
			minSubmitDeadlineGap: parseInt($.getStudioSetting('minimumSubmitDeadlineGap', '14')),
			publisherContract: $.getStudioSetting('publisherContract'),
			plicSlug: $.plicSlug,
			projectTypes,
			existingProject: $.activeProjectRow
		};
	},
	events: {
		insertProject: function(projectData) {
			let project = $.extend(projectData, {
				status: '-',
				pdf: {
					id: '-',
					pages: null,
					loading: false
				},
				cover: {
					id: '-'
				},
				pageLimit: projectData.settings.pageLimit,
				projectType: projectData.settings.projectType,
				storeEnabled: false,
				deadline: projectData.deadline
			});
	
			$('#organizationTable').dataTable().fnAddDataAndDisplay(project);
			window.addSchoolToDropdown(project);
	
			window.returnToMainTab();
		},
		done() {
			$.organizationDataTable?.dataTable().fnDisplayUpdatedData($.activeProjectRow);
			$.publisherOrdersTable?.dataTable().fnDisplayUpdatedData($.activeProjectRow);
			window.returnToMainTab();
		}
	},
	component: () => import(/* webpackChunkName: "PublisherOrderWizard" */ '../management/tabs/publisher-order-wizard/Wizard.vue')
};

window.tabComponents.YearbookReview = {
	props: () => {
		return {
			project: $.activeProjectRow
		};
	},
	events: {
		done() {
			window.returnToMainTab();
		}
	},
	component: () => import(/* webpackChunkName: "YearbookReview" */ '../management/tabs/yearbook-review/YearbookReview.vue')
};

import LayoutGridDisplay from './tabs/layouts/grid/LayoutGridDisplay.vue';
Vue.component('layout-grid-display', LayoutGridDisplay);
import '../js/tab-components/order-importer';